import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User, UserSettings } from '@2enbota/shared';

interface AuthState {
  user: User | null;
  settings: UserSettings | null;
  initData: string | null;
  isLoading: boolean;
  isInitialized: boolean;

  setUser: (user: User) => void;
  setSettings: (settings: UserSettings) => void;
  setInitData: (initData: string) => void;
  setLoading: (loading: boolean) => void;
  setInitialized: (initialized: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      settings: null,
      initData: null,
      isLoading: true,
      isInitialized: false,

      setUser: (user) => set({ user }),
      setSettings: (settings) => set({ settings }),
      setInitData: (initData) => set({ initData }),
      setLoading: (isLoading) => set({ isLoading }),
      setInitialized: (isInitialized) => set({ isInitialized }),
      logout: () => set({ user: null, settings: null, initData: null }),
    }),
    {
      name: '2enbota-auth',
      partialize: (state) => ({ settings: state.settings }),
    }
  )
);
